import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faBuilding } from "@fortawesome/free-solid-svg-icons";
import CorporateList from "./CorporateList";

const CorporatePage = () => {
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 md:p-6">
      <div className="max-w-1xl mx-auto space-y-6">
        {/* Header */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="p-3 bg-white rounded-2xl shadow-md transform transition hover:scale-105">
              <FontAwesomeIcon icon={faBuilding} className="text-indigo-600 text-lg" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-800 tracking-tight">
                Corporate Management
              </h1>
              <p className="text-sm text-gray-500 mt-1">Manage corporate entities and funding</p>
            </div>
          </div>
          <div className="flex items-center gap-3 w-full sm:w-auto">
            <div className="relative flex-1 sm:flex-initial">
              <input
                type="text"
                placeholder="Search Corporates..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full sm:w-64 px-4 py-2 bg-white border border-gray-200 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm"
              />
              <FontAwesomeIcon
                icon={faSearch}
                className="absolute right-3 top-2.5 text-gray-400 text-sm"
              />
            </div>
            <button className="px-4 py-2 bg-gradient-to-r from-indigo-500 to-purple-600 text-white rounded-lg shadow-md hover:from-indigo-600 hover:to-purple-700 transition-all duration-200 text-sm font-medium">
              <FontAwesomeIcon icon={faBuilding} className="mr-2 text-xs" />
              Add New Corporate
            </button>
          </div>
        </div>

        {/* Corporate List Component */}
        <CorporateList searchTerm={searchTerm} />
      </div>
    </div>
  );
};

export default CorporatePage;